module.exports = __webpack_public_path__ + "img/card_santiagodechileebus_background.19cb7a76.png";